// extracted by mini-css-extract-plugin
module.exports = {"post-content":"post_post-content__PNXj5","block-marketing":"post_block-marketing__gysBV"};